/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable react-native/no-color-literals */
import React from 'react';
import { View, ScrollView, TouchableOpacity, StyleSheet } from 'react-native';
import { useDispatch } from 'react-redux';
import { isWeb, fullWidth } from '@global/screens';
import Colors from '@global/colors';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import { showImage } from '@/store/global';

const widthContainer = isWeb ? '100%' : fullWidth - 30;
const photoSize = isWeb ? 180 : (widthContainer - 20) / 2;

const CompetitorUpdateSection = ({ images = [] }) => {
  const dispatch = useDispatch();
  const hasData = images && images.length > 0;

  const ImageButton = ({ item }) => {
    const url = item.url;
    const text = item.text || '';
    return (
      <TouchableOpacity
        onPress={() => {
          dispatch(
            showImage({
              isModal: true,
              text,
              disableCDN: true,
              isMultiple: true,
              allImage: [url],
              url,
              noArrow: true,
            }),
          );
        }}
        style={[styles.imageThumb, { width: photoSize, height: photoSize }]}>
        <Image
          style={{ width: photoSize, height: photoSize }}
          width={photoSize}
          height={photoSize}
          source={url}
          disableCDN={true}
        />
        {text ? (
          <View style={styles.imageCaption}>
            <SociollaText style={styles.imageCaptionText} numberOfLines={2}>
              {text}
            </SociollaText>
          </View>
        ) : null}
      </TouchableOpacity>
    );
  };

  return (
    <ScrollView
      testID="todo-competitor-update-display-container"
      showsVerticalScrollIndicator={false}
      style={{ width: '100%' }}
      contentContainerStyle={{ padding: 15 }}>
      <View style={styles.card}>
        {/* Top accent bar */}
        <View style={styles.cardAccent} />

        {/* Header */}
        <View style={styles.cardHeader}>
          <SociollaText type="semibold" style={styles.cardTitle}>
            Competitor Update
          </SociollaText>
          <View style={styles.photoBadge}>
            <SociollaText style={styles.photoBadgeText}>
              {hasData
                ? `${images.length} Photo${images.length > 1 ? 's' : ''}`
                : 'No photos'}
            </SociollaText>
          </View>
        </View>

        <View style={styles.cardDivider} />

        {/* Photo section */}
        <View style={styles.cardSection}>
          <SociollaText style={styles.sectionLabel}>Photos</SociollaText>
          {hasData ? (
            <ScrollView horizontal showsHorizontalScrollIndicator={false}>
              <View style={{ flexDirection: 'row' }}>
                {images.map((item, idx) => (
                  <ImageButton item={item} key={idx} />
                ))}
              </View>
            </ScrollView>
          ) : (
            <View style={styles.emptyState}>
              <Image
                style={{ width: 36, height: 36, marginBottom: 8, opacity: 0.5 }}
                width={36}
                height={36}
                svg={true}
                source={require('@assets/img/icons/gallery-grey.svg')}
              />
              <SociollaText style={styles.emptyStateText}>
                No competitor display photos recorded for this visit
              </SociollaText>
            </View>
          )}
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  card: {
    width: '100%',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: Colors.grey0,
    backgroundColor: Colors.white,
    overflow: 'hidden',
    marginBottom: 14,
  },
  cardAccent: {
    height: 4,
    width: '100%',
    backgroundColor: Colors.blue0,
  },
  cardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 14,
    paddingVertical: 10,
  },
  cardTitle: {
    fontSize: 13,
    color: Colors.blue1,
  },
  photoBadge: {
    paddingHorizontal: 10,
    paddingVertical: 3,
    borderRadius: 20,
    backgroundColor: Colors.grey15,
  },
  photoBadgeText: {
    fontSize: 11,
    color: Colors.grey13,
  },
  cardDivider: {
    height: 1,
    backgroundColor: Colors.grey0,
  },
  cardSection: {
    paddingHorizontal: 14,
    paddingVertical: 10,
  },
  sectionLabel: {
    fontSize: 11,
    color: Colors.grey1,
    marginBottom: 10,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  imageThumb: {
    borderRadius: 8,
    overflow: 'hidden',
    marginRight: 10,
  },
  imageCaption: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    paddingVertical: 6,
    paddingHorizontal: 8,
    backgroundColor: 'rgba(0,0,0,0.55)',
  },
  imageCaptionText: {
    fontSize: 10,
    color: Colors.white,
  },
  emptyState: {
    paddingVertical: 24,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.grey0,
    borderStyle: 'dashed',
  },
  emptyStateText: {
    fontSize: 12,
    color: Colors.grey1,
    textAlign: 'center',
  },
});

export default CompetitorUpdateSection;
